export default {
  "content": "<path d=\"M4.925 10.344L0 5.419l1.312-1.312 3.656 3.656L12.731 0 14 1.269l-9.075 9.075z\" fill=\"currentColor\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "11",
    "viewBox": "0 0 14 11",
    "fill": "none"
  }
};